/**
 * design_handoff_auth §5 — Google signed the user in fine; there's just no
 * Revisual account on this address. This is not an error state: no red
 * panel, no "does not exist", no green outline button, no "or" divider
 * between two competing buttons.
 * Created by piotr.pozniak@thebeaverhead.com on 05/12/2022
 */

import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Button } from "../../theme/untitled";
import AuthAlert from "../AuthPages/AuthAlert";
import useRedirectUrl from "../../hooks/useRedirectUrl";
import styles from "../AuthPages/authForm.module.scss";

const AccountNotFound = (props) => {
  const { createUrlWithRedirect } = useRedirectUrl();

  const onCreateAccount = useCallback(
    (e) => {
      e.preventDefault();
      props.onCreateAccount();
    },
    [props.onCreateAccount]
  );

  return (
    <div>
      <h1 className={styles.title}>No Revisual account yet</h1>
      <p className={styles.sub}>
        Google signed you in fine — there's just no Revisual account on this address.
      </p>

      <AuthAlert variant="info">
        <b>{props.email}</b>
        Sign up with this address and we'll keep the Google connection, so you never
        need a password.
      </AuthAlert>

      <div className={styles.fields}>
        <Button fullWidth onClick={onCreateAccount}>
          Create a free account
        </Button>
      </div>

      <p className={styles.footQuestion}>
        Wrong address?
        <Link to={createUrlWithRedirect("/login")}>Back to log in</Link>
      </p>
    </div>
  );
};

AccountNotFound.defaultProps = {};

AccountNotFound.propTypes = {
  email: PropTypes.string,
  onCreateAccount: PropTypes.func.isRequired,
};

export default AccountNotFound;
